var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyIconDefault = function SvgCopyIconDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0481A0",
    fillRule: "evenodd",
    d: "M8.538 14.77h11.077V7.845H8.538v6.923zm.692-.693h9.693V8.538H9.23v5.539zM21 6.462H7.153v9c0 .382.31.692.693.692h12.461c.382 0 .693-.31.693-.692v-9zm1.384-1.385v10.385c0 1.147-.93 2.076-2.077 2.076H7.846a2.077 2.077 0 0 1-2.077-2.076V5.077C5.769 3.93 6.699 3 7.846 3h12.461c1.147 0 2.077.93 2.077 2.077zm-5.538 13.846h1.384c0 1.147-.93 2.077-2.077 2.077H3.692a2.077 2.077 0 0 1-2.077-2.077V8.538c0-1.147.93-2.076 2.077-2.076h.692v3.461H3v9c0 .382.31.692.692.692h12.461c.383 0 .693-.31.693-.692z"
  })));
};

export default SvgCopyIconDefault;